import {
  VStack,
  HStack,
  Box,
  Text,
  AspectRatio,
  Image,
  StackDivider,
  Icon,
  Heading,
  Collapse,
  useDisclosure,
} from '@chakra-ui/react';

import PageContainer from '~/containers/PageContainer';
import Content from '~/containers/Content';

import OperatingTime from '~/components/OperatingTimeList';
import SectionLabel from '~/components/SectionLabel';
import BackwardBar from '~/components/BackwardBar';
import LocationBar from '~/components/LocationBar';

import {
  IoLocationOutline,
  IoTimeOutline,
  IoRemoveCircleOutline,
  IoChevronUpOutline,
  IoChevronDownOutline,
} from 'react-icons/io5';
import { AiOutlineShop } from 'react-icons/ai';

import { useNavigate } from 'react-router-dom';

import storeInfoAtom from '~/recoil/atom/storeInfo';
import { useRecoilValue } from 'recoil';

import defaultImage from '~/assets/images/defaultImage.png';
import format from 'date-fns/format';
import isAfter from 'date-fns/isAfter';
import endOfYesterday from 'date-fns/endOfYesterday';

export default function StoreInfo() {
  const navigate = useNavigate();
  const storeInfo = useRecoilValue(storeInfoAtom);
  const { isOpen, onToggle } = useDisclosure();
  const yesterday = endOfYesterday();

  return (
    <PageContainer
      hideHeader
      hideNavBar
      afterHeaderComponent={
        <>
          <BackwardBar title="返回" onNavigate={() => navigate(-1)} />
          <LocationBar />
          <Box px={4} bgColor="white">
            <Content>
              <HStack py={2}>
                <AspectRatio w="35px" ratio={1 / 1} borderRadius="full">
                  <Image borderRadius="full" src={storeInfo.logo || defaultImage} />
                </AspectRatio>
                <Heading size="sm">{storeInfo.name}</Heading>
              </HStack>
            </Content>
          </Box>
        </>
      }
    >
      <Box>
        <Content>
          <AspectRatio ratio={3 / 2}>
            <Image src={storeInfo.banners[0] || defaultImage} />
          </AspectRatio>
        </Content>
      </Box>

      <Box px={4}>
        <Content as="main" py={5}>
          <VStack align="stretch" spacing={4} divider={<StackDivider borderColor="gray.400" />}>
            {/** store base info */}
            <VStack as="section" align="flex-start" spacing={2}>
              {/* <HStack>
                <Icon as={IoCallOutline} boxSize="1.25rem" color="gray.500" />
                <Text fontSize="sm">02-234-567-899</Text>
              </HStack> */}
              <HStack>
                <Icon as={IoLocationOutline} boxSize="1.25rem" color="gray.500" />
                <Text fontSize="sm">{storeInfo.location.address}</Text>
              </HStack>
            </VStack>

            <VStack as="section" align="stretch" spacing={2}>
              <HStack justifyContent="space-between">
                <SectionLabel title="公休日" icon={IoRemoveCircleOutline} />
                <Icon
                  as={isOpen ? IoChevronUpOutline : IoChevronDownOutline}
                  color="gray.500"
                  boxSize="1.125rem"
                  onClick={onToggle}
                  cursor="pointer"
                />
              </HStack>
              <Collapse in={isOpen}>
                <VStack justifyContent="flex-start" alignItems="self-start">
                  {storeInfo.officialHoliday
                    .filter((date) => isAfter(date, yesterday))
                    .map((date) => (
                      <Text textAlign="left" fontSize="sm">
                        {format(date, 'yyyy-MM-dd')}
                      </Text>
                    ))}
                </VStack>
              </Collapse>
            </VStack>

            {/** store operating time */}
            <VStack as="section" align="stretch" spacing={2}>
              <SectionLabel title="營業時間" icon={IoTimeOutline} />
              <OperatingTime operatingTime={storeInfo.preOrderSetting.schedule} />
            </VStack>

            {/** store description */}
            {storeInfo.description && (
              <VStack as="section" align="stretch" spacing={2}>
                <SectionLabel title="店家描述" icon={AiOutlineShop} />
                <Text fontSize="sm">{storeInfo.description}</Text>
              </VStack>
            )}
          </VStack>
        </Content>
      </Box>
    </PageContainer>
  );
}
